let messagesMapper = [
    {
        key: 'Security group rule already exists.',
        value: 'Security group rule already exists'
    },
    {
        key: 'Quota exceeded for resources:',
        value: 'Quota exceeded for resources'
    },
    {
        key: 'Volume attachments can not be created if the volume is in an error state',
        value: 'Volume attachments can not be created if the volume is in an error state'
    },
    {
        key: 'while it is in task_state image_pending_upload',
        value: 'A volume cannot be attached/detached to an instance when a snapshot creation is in progress for the instance. Try again in sometime.'
    },
    {
        key: 'while it is in task_state image_uploading',
        value: 'A volume cannot be attached/detached to an instance when a snapshot creation is in progress for the instance. Try again in sometime.'
    },
    {
        key: 'Volume attachments can not be created if the volume is in an error state',
        value: 'Volume could not be attached as it is in error state'
    },
    {
        key: 'while it is in vm_state rescued',
        value: 'Attach/Detach cannot be performed on rescued instance'
    },
    {
        key: 'while it is in vm_state shelved_offloaded',
        value: 'Attach/Detach cannot be performed on shelved account'
    },
    {
        key: 'while it is in vm_state stopped',
        value: 'Password cannot be changed when instance is shut down or starting'
    },
    {
        key: 'Invalid volume: Volume to be restored to must be available',
        value: 'Volume is backing up. Try after volume backup completion'
    },
    {
        key: 'Invalid volume: Volume status must be available or error or error_restoring or error_extending or error_managing and must not be migrating, attached, belong to a group, have snapshots or be disassociated from snapshots after volume transfer.',
        value: 'Volume is restoring up. Try after sometime'
    },
    {
        key: 'to extend, currently restoring-backup',
        value: 'Volume is restoring up. Try after sometime'
    },
    {
        key: 'status must be available or downloading to reserve, but the current status is restoring-backup',
        value: 'Volume is restoring up. Try after sometime'
    },
    {
        key: 'Volume to be backed up must be available or in-use, but the current status is',
        value: 'Volume is restoring up. Try after sometime'
    },
    {
        key: 'forced_host to be performed.',
        value: 'Internal server error. <a href="https://www.idrivecompute.com/support.htm" target = "_blank"> Contact support</a>'
    },
    {
        key: 'Quota exceeded for instances:',
        value: 'You have created <a href="https://www.idrivecompute.com/faq_plans.htm#3" target = "_blank">maximum instances</a> allowed in the selected region,<a href="https://www.idrivecompute.com/support.htm" target = "_blank"> Contact support</a> to increase this limit.'
    },
    {
        key: 'Quota exceeded for cores:',
        value: 'You have created <a href="https://www.idrivecompute.com/faq_plans.htm#3" target = "_blank">maximum instances</a> allowed in the selected region,<a href="https://www.idrivecompute.com/support.htm" target = "_blank"> Contact support</a> to increase this limit.'
    },
    {
        key: 'No valid host was found',
        value: 'Instance could not be allocated at the moment due to resource unavailability. We regret the inconvenience. Kindly <a href="https://www.idrivecompute.com/support.htm" target = "_blank"> Contact support</a> for help.'
    },
    {
        key: 'Exceeded maximum number of retries. Exhausted all hosts available for retrying build failures for instance',
        value: 'Exceeded maximum number of retries. Exhausted all hosts available for retrying build failures of the instance, <a href="https://www.idrivecompute.com/support.htm" target = "_blank"> Contact support</a> for help.'
    },
    {
        key: 'Invalid input received',
        value: 'Volume creation is in progress. It may take some time to complete. Try to attach the volume after few minutes or <a href="https://www.idrivecompute.com/support.htm" target = "_blank"> Contact support</a> for help.'
    },
    {
        key: 'Invalid volume',
        value: 'Volume is unavailable at this moment. Try after sometime'
    },
    {
        key: 'user_not_found',
        value: 'The request made cannot be linked with a compute account. Please try again or contact support for further assistance.'
    },
    {
        key: 'invalid_state',
        value: 'The request made cannot be validated. Please try again or contact support for further assistance.'
    },
    {
        key: 'permission_denied',
        value: 'The requested permissions were denied, aborting $action$.'
    },
    {
        key: 'internal_error',
        value: 'The server could not complete your operation(s) without encountering an error, likely due to a transient issue on our end. It\'s possible some aspect of the operation succeeded before the error was raised.'
    },
    {
        key: 'popup_closed',
        value: 'The $action$ was terminated by closing the window.'
    }

];

export const getMessage = (messg) => {
    if(messg === undefined || typeof messg !== "string") {
        return messg;
    }
    console.log(messg);
    let ob = messagesMapper.find(item => messg.includes(item.key));
    if(ob !== undefined) {
        return ob.value;
    }
    return messg;
};
export default messagesMapper;